<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>考务管理</el-breadcrumb-item>
      <el-breadcrumb-item
        :to="{
          path: '/individual_manage_homeview/individual_race_management',
        }"
        >个人赛考务管理</el-breadcrumb-item
      >
      <el-breadcrumb-item>合作赛事</el-breadcrumb-item>
      <el-breadcrumb-item>朗思测评</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- 考场筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">选手筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="90px"
        ref="queryFormRef"
      >
        <el-row :gutter="50">
          <el-col :span="8">
              <el-form-item label="所属赛区" prop="districtId">
                  <el-select
                      placeholder="请选择"
                      style="width: 100%"
                      v-model="queryForm.districtId"
                      clearable
                      multiple
                  >
                      <el-option
                          v-for="item in dict_district"
                          :key="item.id"
                          :label="item.districtName"
                          :value="item.id"
                      ></el-option>
                  </el-select>
              </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="queryForm.userName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系方式" prop="phone">
              <el-input
                v-model="queryForm.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="handleToSearch"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="handleToReset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- 考场管理 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col :span="12">
          <span class="title_class">选手管理</span>
        </el-col>
        <el-col :span="12">
          <div class="div_algin_right">
            <el-button class="mr-10" type="primary" plain size="small" icon="el-icon-lock" @click="showSetDialog">锁定考生注册表</el-button>
            <el-button class="mr-10" type="primary" plain size="small" icon="el-icon-download" @click="exportExcel">批量导出</el-button>
          </div>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index" width="50px"></el-table-column>
        <el-table-column label="赛区" prop="districtName"></el-table-column>
        <el-table-column label="姓名" prop="userName"></el-table-column>
        <el-table-column label="手机号">
              <template slot-scope="scope">
                <MaskedPhone :phone="scope.row.phone" />
              </template>
            </el-table-column>
        <!-- <el-table-column label="晋级状态" prop="promotion">
          <template slot-scope="scope">
            <el-tag :type="scope.row.promotion === 0 ? 'info' : scope.row.promotion === 1 ? 'success' : scope.row.promotion === 2 ? 'danger' : '' " size="mini">
              {{ scope.row.promotion === 0 ? '未设置' : scope.row.promotion === 1 ? '晋级' : scope.row.promotion === 2 ? '未晋级' : ''  }}
            </el-tag>
          </template>
        </el-table-column> -->
        <el-table-column label="组别" prop="level" :formatter="levelFormat"></el-table-column>
        <el-table-column label="年级" prop="grade" :formatter="gradeFormat"></el-table-column>
        <el-table-column label="学校" prop="schoolName"></el-table-column>
        <el-table-column label="提交考生注册表" prop="lanceUserInfoPerfectState">
          <template slot-scope="scope">
            <el-tag :type="!scope.row.lanceUserInfoPerfectState ? 'danger' : 'success' " size="mini">
              {{ !scope.row.lanceUserInfoPerfectState ? '未提交' : '已提交'}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="修改考生注册表" prop="editState">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.editState"
              @change="editFormFn(scope.row)"
              active-color="#13ce66">
            </el-switch>
            <div>
            {{ scope.row.editState ? '允许修改' : '不可修改' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="140px">
          <template slot-scope="scope">
            <el-button
              type="text"
              :disabled="!scope.row.lanceUserInfoPerfectState"
              size="small"
              style="margin-right: 12px;"
              @click="showDialog(scope.row)"
              >考生注册信息</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <el-dialog
      title="考生注册表"
      :visible.sync="visible"
      width="1000px"
      :before-close="handleClose">
      <el-descriptions :column="3" size="small" border>
        <el-descriptions-item label="姓">{{ lanceInfo.lastName }}/{{ lanceInfo.lastNameLatin }}</el-descriptions-item>
        <el-descriptions-item label="名">{{ lanceInfo.firstName }}/{{ lanceInfo.firstNameLatin }}</el-descriptions-item>
        <el-descriptions-item label="母语">{{ lanceInfo.nativeLanguage }}</el-descriptions-item>
        <el-descriptions-item label="性别">{{ lanceInfo.gender }}</el-descriptions-item>
        <el-descriptions-item label="手机号码"><MaskedPhone :phone="lanceInfo.mobile" /></el-descriptions-item>
        <el-descriptions-item label="邮箱">{{ lanceInfo.primaryEmail }}</el-descriptions-item>
        <el-descriptions-item label="邮寄地址">{{ lanceInfo.postalAddress }}</el-descriptions-item>
        <el-descriptions-item label="邮编">{{ lanceInfo.postalCode }}</el-descriptions-item>
        <el-descriptions-item label="国家">{{ lanceInfo.country }}</el-descriptions-item>
        <el-descriptions-item label="城市">{{ lanceInfo.city }}</el-descriptions-item>
        <el-descriptions-item label="证件类型">{{ lanceInfo.photoIDType }}</el-descriptions-item>
        <el-descriptions-item label="证件号码">{{ lanceInfo.photoIDNumber }}</el-descriptions-item>
        <el-descriptions-item label="生日">{{ lanceInfo.birthDate }}</el-descriptions-item>
        <el-descriptions-item label="证书上考生姓名的显示语言">{{ lanceInfo.alphabetOfNameOnCertificate }}</el-descriptions-item>
        <el-descriptions-item label="证书上显示考生姓与名的顺序">{{ lanceInfo.nameOnCertificate }}</el-descriptions-item>
        <el-descriptions-item label="修改考生注册表">
          <el-switch
            v-model="value"
            @change="editFn"
            active-color="#13ce66">
          </el-switch>
          {{ value ? '允许修改' : '不可修改' }}
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>

    <el-dialog
      title="设置"
      :visible.sync="setVisible"
      width="400px">
      <div style="font-size: 12px; margin-bottom: 20px;">选择赛区，批量设置本赛区「考生注册表」是否允许考生修改。建议在导出数据前设置为不允许考生修改，以免考生信息有误。</div>
      <div class="item">
        <div class="key">赛区</div>
        <el-select
          placeholder="请选择"
          v-model="districtId"
          class="value"
        >
          <el-option
              v-for="item in dict_district"
              :key="item.id"
              :label="item.districtName"
              :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="item">
        <div class="key">修改考生注册表</div>
        <el-select
          placeholder="请选择"
          v-model="lockState"
          class="value"
        >
          <el-option label="允许修改" :value="false"></el-option>
          <el-option label="不可修改" :value="true"></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setVisible = false">取 消</el-button>
        <el-button type="primary" @click="setLockFn">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import { queryDistrictPage, resetAllUser, resetSingleUser, queryUnselectedRoomUserList, batchExaminationRoom } from '@/http/api'
export default {
  data () {
    return {
      dataList: [],
      dict_district: [],
      total: 0,
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        roomId: this.$route.query.id,
        userName: '',
        phone: '',
        schoolName: ''
      },
      addPlayerModel: {
        phones: ''
      },
      addPlayerRules: {
        phones: [{ required: true, message: '请输入选手账号', trigger: 'blur' }]
      },
      dict_group: this.$userInfo.dict_group(),
      dict_grade: this.$userInfo.getGradeData(),
      stuVisible: false,
      stuList: [],
      visible: false,
      lanceInfo: {},
      value: false,
      setVisible: false,
      districtId: '',
      lockState: '' // 批量设置锁定状态
    }
  },
  created () {
    this.getDistrictList()
    this.getList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 获取赛区筛选数据
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
      }).catch((err) => {
        console.log('err', err)
      })
    },
    handleToSearch () {
      this.queryForm.pageNum = 1
      this.getList()
    },
    handleToReset () {
      this.$refs.queryFormRef.resetFields()
      this.getList()
    },
    handleClose () {
      this.visible = false
      this.getList()
    },
    async getList () {
      this.$http.get('enrollmentLance/queryPage', { params: this.queryForm }).then(res => {
        this.dataList = res.data.list
        this.dataList.forEach(item => {
          item.editState = !item.lanceUserInfoLockState
        })
        this.total = res.data.total
      })
    },
    handleSizeChange (e) {
      this.queryForm.pageSize = e
      this.getList()
    },
    handleCurrentChange (e) {
      this.queryForm.pageNum = e
      this.getList()
    },
    async showEditDialog (row) {
      this.$confirm('是否重置该学生?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        resetSingleUser({ id: row.id }).then(res => {
          this.$message.success('已重置')
          this.handleToSearch()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消'
        // })
      })
    },
    resetAllFn () {
      this.$confirm('是否重置考场内所有学生?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        resetAllUser({ id: this.queryForm.roomId }).then(res => {
          this.$message.success('已全部重置')
          this.handleToSearch()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消'
        // })
      })
    },
    exportExcel () {
      var downLoadUrl = this.$env.baseIP + 'enrollmentLance/exportExcelList'
      console.log('downLoadUrl', downLoadUrl)
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, '', this.queryForm)
    },
    levelFormat (row) {
      const level = row.level
      return level || level === 0 ? this.dict_group.find(item => Number(item.dictValue) === level).dictLabel : '-'
    },
    gradeFormat (row) {
      const grade = row.grade
      return grade ? this.dict_grade.find(item => item.dictCode === grade).dictLabel : '-'
    },
    handleToSubmit () {
      this.$refs.dataFormRef.validate(async valid => {
        if (!valid) return false
        delete this.dataForm.dateRange
        const { data: res } = this.editType === 0 ? await this.$http.post('erp/nascc/certificate/create', this.dataForm) : await this.$http.put(`erp/nascc/certificate/edit/${this.editId}`, this.dataForm)
        if (res.code !== 0) {
          this.$message.error(res.message)
        } else {
          this.$message.success('保存成功')
          this.handleCloseDialog()
          this.getList()
        }
      })
    },
    handleToDetails (row) {
      this.$router.push({
        path: '/match_thing_manage/sspcn/certificateDetails',
        query: {
          id: row.id
        }
      })
    },
    daterangeChange (e) {
      if (e.length === 2) {
        this.dataForm.beginTime = e[0]
        this.dataForm.endTime = e[1]
      }
    },
    showStudents () {
      // 调接口
      queryUnselectedRoomUserList(this.addQueryForm).then(res => {
        this.stuList = res.data
      })
    },
    handleCloseDialog () {
      this.stuVisible = false
    },
    handleSelectionChange (arr) {
      // console.log(arr)
      this.phones = arr.map(item => item.phone)
    },
    handleToAdd () {
      batchExaminationRoom({
        roomId: this.queryForm.roomId,
        phones: this.addPlayerModel.phones
      }).then(res => {
        this.$message.success('添加成功')
        this.handleCloseDialog()
        this.handleToSearch()
      })
    },
    showDialog (item) {
      this.$http.get('enrollmentLance/getEnrollmentLanceUserInfoByLanceId?id=' + item.id).then(res => {
        if (res.code === 200) {
          this.lanceInfo = res.data
          this.visible = true
          this.value = !this.lanceInfo.lockState
        }
      })
    },
    showSetDialog () {
      this.districtId = ''
      this.lockState = ''
      this.setVisible = true
    },
    editFn () {
      console.log(this.value)
      this.$http.post('enrollmentLance/updateLockState', {
        id: this.lanceInfo.id,
        lockState: !this.value
      }).then(res => {
        if (res.code === 200) {
          // this.$message.success(this.value ? '' : '')
        }
      })
    },
    editFormFn (item) {
      this.$http.post('enrollmentLance/updateLockState', {
        id: item.lanceUserInfoId,
        lockState: !item.editState
      }).then(res => {
        if (res.code === 200) {
          this.getList()
          // this.$message.success(this.value ? '' : '')
        }
      })
    },
    setLockFn () {
      this.$http.post('enrollmentLance/updateBatchLockState', {
        id: this.districtId,
        lockState: this.lockState
      }).then(res => {
        if (res.code === 200) {
          this.setVisible = false
          this.$message.success('设置成功')
          this.getList()
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.div_algin_right{
  text-align: right;
}
.item{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.key{
  width: 120px;
  font-size: 14px;
  text-align: right;
  margin-right: 10px;
}
.value{
  width: 300px;
}
</style>
